export default function PHP_xml_get_current_line_number() {
  return (
    <div>
      <h1>PHP_xml_get_current_line_number</h1>
    </div>
  );
}
